export const numberRender: (value: string | number) => string = value =>
  `₦${Number(value).toLocaleString()}`;

export const statusRender: (status: boolean) => JSX.Element = status => {
  return status ? (
    <span className="tag success">Active</span>
  ) : (
    <span className="tag failure">Inactive</span>
  );
};

export const percentRender: (
  percentage: number | string
) => string = percentage => `${percentage}%`;

export const descriptionRender: (
  description: string
) => string = description => {
  const MAX_DESC_CHARACTERS = 30;
  return `${String(description || "").slice(0, MAX_DESC_CHARACTERS)}${
    (description?.length || 0) > MAX_DESC_CHARACTERS ? " ..." : ""
  }`;
};
